export default __webpack_public_path__ + "static/media/b23.22d30341.png";